module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_Black.e10e2b42.jpg";